import _slicedToArray from "/Users/dom/src/deeplocal/maps-tycoon-2020/node_modules/@babel/runtime/helpers/esm/slicedToArray";
export var MATH = function MATH(op) {
  return function (_ref) {
    var _ref2 = _slicedToArray(_ref, 3),
        o = _ref2[0],
        a = _ref2[1],
        b = _ref2[2];

    return "".concat(o, "=").concat(a).concat(op).concat(b, ";");
  };
};
export var MATH_N = function MATH_N(op) {
  return function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        o = _ref4[0],
        a = _ref4[1];

    return "".concat(o, "=").concat(a).concat(op, "n;");
  };
};
export var FN = function FN(op) {
  return function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        o = _ref6[0],
        a = _ref6[1];

    return "".concat(o, "=").concat(op, "(").concat(a, ");");
  };
};
export var FN2 = function FN2(op) {
  return function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 3),
        o = _ref8[0],
        a = _ref8[1],
        b = _ref8[2];

    return "".concat(o, "=").concat(op, "(").concat(a, ",").concat(b, ");");
  };
};
export var FN_N = function FN_N(op) {
  return function (_ref9) {
    var _ref10 = _slicedToArray(_ref9, 2),
        o = _ref10[0],
        a = _ref10[1];

    return "".concat(o, "=").concat(op, "(").concat(a, ",n);");
  };
};
export var DOT = function DOT(_ref11) {
  var _ref12 = _slicedToArray(_ref11, 2),
      a = _ref12[0],
      b = _ref12[1];

  return "".concat(a, "*").concat(b);
};
export var DOT_G = function DOT_G(_ref13) {
  var _ref14 = _slicedToArray(_ref13, 2),
      a = _ref14[0],
      b = _ref14[1];

  return "s+=".concat(a, "*").concat(b, ";");
};
export var SET = function SET(_ref15) {
  var _ref16 = _slicedToArray(_ref15, 2),
      o = _ref16[0],
      a = _ref16[1];

  return "".concat(o, "=").concat(a, ";");
};
export var SET_N = function SET_N(_ref17) {
  var _ref18 = _slicedToArray(_ref17, 1),
      a = _ref18[0];

  return "".concat(a, "=n;");
};
export var HOF_VVV = function HOF_VVV(_ref19) {
  var _ref20 = _slicedToArray(_ref19, 4),
      o = _ref20[0],
      a = _ref20[1],
      b = _ref20[2],
      c = _ref20[3];

  return "".concat(o, "=op(").concat(a, ",").concat(b, ",").concat(c, ");");
};
export var HOF_VVVVV = function HOF_VVVVV(_ref21) {
  var _ref22 = _slicedToArray(_ref21, 6),
      o = _ref22[0],
      a = _ref22[1],
      b = _ref22[2],
      c = _ref22[3],
      d = _ref22[4],
      e = _ref22[5];

  return "".concat(o, "=op(").concat(a, ",").concat(b, ",").concat(c, ",").concat(d, ",").concat(e, ");");
};
export var ADDM = function ADDM(_ref23) {
  var _ref24 = _slicedToArray(_ref23, 4),
      o = _ref24[0],
      a = _ref24[1],
      b = _ref24[2],
      c = _ref24[3];

  return "".concat(o, "=(").concat(a, "+").concat(b, ")*").concat(c, ";");
};
export var ADDM_N = function ADDM_N(_ref25) {
  var _ref26 = _slicedToArray(_ref25, 3),
      o = _ref26[0],
      a = _ref26[1],
      b = _ref26[2];

  return "".concat(o, "=(").concat(a, "+").concat(b, ")*n;");
};
export var MADD = function MADD(_ref27) {
  var _ref28 = _slicedToArray(_ref27, 4),
      o = _ref28[0],
      a = _ref28[1],
      b = _ref28[2],
      c = _ref28[3];

  return "".concat(o, "=").concat(a, "+").concat(b, "*").concat(c, ";");
};
export var MADD_N = function MADD_N(_ref29) {
  var _ref30 = _slicedToArray(_ref29, 3),
      o = _ref30[0],
      a = _ref30[1],
      b = _ref30[2];

  return "".concat(o, "=").concat(a, "+").concat(b, "*n;");
};
export var MIX = function MIX(_ref31) {
  var _ref32 = _slicedToArray(_ref31, 4),
      o = _ref32[0],
      a = _ref32[1],
      b = _ref32[2],
      c = _ref32[3];

  return "".concat(o, "=").concat(a, "+(").concat(b, "-").concat(a, ")*").concat(c, ";");
};
export var MIX_N = function MIX_N(_ref33) {
  var _ref34 = _slicedToArray(_ref33, 3),
      o = _ref34[0],
      a = _ref34[1],
      b = _ref34[2];

  return "".concat(o, "=").concat(a, "+(").concat(b, "-").concat(a, ")*n;");
};
export var SUBM = function SUBM(_ref35) {
  var _ref36 = _slicedToArray(_ref35, 4),
      o = _ref36[0],
      a = _ref36[1],
      b = _ref36[2],
      c = _ref36[3];

  return "".concat(o, "=(").concat(a, "-").concat(b, ")*").concat(c, ";");
};
export var SUBM_N = function SUBM_N(_ref37) {
  var _ref38 = _slicedToArray(_ref37, 3),
      o = _ref38[0],
      a = _ref38[1],
      b = _ref38[2];

  return "".concat(o, "=(").concat(a, "-").concat(b, ")*n;");
};